import { isTrackingEnabled } from './is-tracking-enabled';

// GTM is disabled for now (GTag not actively used). Kept for future re-enable.
// const GTM_SCRIPT_ID = 'humeo-gtm-script';
const META_PIXEL_SCRIPT_ID = 'humeo-meta-pixel-script';
// const DEFAULT_GTM_ID = 'GTM-NGTZX75F';
const DEFAULT_META_PIXEL_ID = '1668967577253840';

type FbqFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  loaded?: boolean;
  version?: string;
};

// const getGtmId = (): string =>
//   String(import.meta.env.VITE_GTM_ID || DEFAULT_GTM_ID).trim();

const getMetaPixelId = (): string =>
  String(import.meta.env.VITE_META_PIXEL_ID || DEFAULT_META_PIXEL_ID).trim();

// const initGoogleTagManager = (): void => {
//   const gtmId = getGtmId();
//   if (!gtmId || document.getElementById(GTM_SCRIPT_ID)) {
//     return;
//   }
//
//   window.dataLayer = window.dataLayer || [];
//   window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
//
//   const script = document.createElement('script');
//   script.id = GTM_SCRIPT_ID;
//   script.async = true;
//   script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;
//   document.head.appendChild(script);
// };

const initMetaPixel = (): void => {
  const metaPixelId = getMetaPixelId();
  if (!metaPixelId) {
    return;
  }

  if (!window.fbq) {
    const fbq: FbqFunction = (...args: unknown[]) => {
      if (fbq.callMethod) {
        fbq.callMethod(...args);
      } else {
        fbq.queue?.push(args);
      }
    };

    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
  }

  if (!document.getElementById(META_PIXEL_SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = META_PIXEL_SCRIPT_ID;
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
  }

  window.fbq?.('init', metaPixelId);
  window.fbq?.('track', 'PageView');
};

const initMarketingTrackers = (): void => {
  if (typeof window === 'undefined' || !isTrackingEnabled()) {
    return;
  }

  // initGoogleTagManager();
  initMetaPixel();
};

export default initMarketingTrackers;
